// extracted by mini-css-extract-plugin
export default {"section":"section__index__Nw613","locations":"locations__index__LHB6W","emptyText":"emptyText__index__eKnWT"};